/** @format */

import React from 'react';

export const HideLarge = ({color}) => {
    return (
        <svg width="30" height="25" viewBox="0 0 30 25" fill="none">
            <path
                d="M1.66634 2.02665L3.37301 0.333313L25.6663 22.6266L23.973 24.3333L19.8663 20.2266C18.333 20.7333 16.7063 21 14.9997 21C8.33301 21 2.63967 16.8533 0.333008 11C1.25301 8.65331 2.71967 6.58665 4.58634 4.94665L1.66634 2.02665ZM14.9997 6.99998C16.0605 6.99998 17.078 7.42141 17.8281 8.17155C18.5782 8.9217 18.9997 9.93911 18.9997 11C18.9997 11.4666 18.9197 11.92 18.773 12.3333L13.6663 7.22665C14.0797 7.07998 14.533 6.99998 14.9997 6.99998ZM14.9997 0.99998C21.6663 0.99998 27.3597 5.14665 29.6663 11C28.573 13.7733 26.7197 16.1733 24.333 17.92L22.4397 16.0133C24.253 14.76 25.7463 13.0533 26.7597 11C24.5597 6.51998 20.013 3.66665 14.9997 3.66665C13.5463 3.66665 12.1197 3.90665 10.7863 4.33331L8.73301 2.29331C10.653 1.46665 12.773 0.99998 14.9997 0.99998ZM3.23967 11C5.43967 15.48 9.98634 18.3333 14.9997 18.3333C15.9197 18.3333 16.8263 18.24 17.6663 18.0533L14.6263 15C12.7197 14.8 11.1997 13.28 10.9997 11.3733L6.46634 6.82665C5.14634 7.95998 4.03967 9.37331 3.23967 11Z"
                fill={color}
            />
        </svg>
    );
};
